import React, { FC, useRef } from 'react';
import cls from 'classnames';
import { Controller, ControllerRenderProps } from 'react-hook-form';
import { InputWithRef } from '@ott/input-next-deprecated';
import FirstErrorShower from '@ott/first-error-shower';
import Button from '@ott/button';
import { l10n } from '@ott/l10n';

import useEmailSubscriptionForm from '../../../../hooks/useEmailSubscriptionForm';
import { FORM_FIELDS, defaultTooltipErrors } from '../../../../constants';
import { AuthType, FormState, MetricsType } from '../../../../types';

import styles from './ModalSubscriptionForm.scss';

type Props = {
  auth?: AuthType;
  className?: string;
  metrics: MetricsType;
  onSuccess: VoidFunction;
};

const SubscriptionForm: FC<Props> = ({ className, onSuccess, metrics, auth }) => {
  const formRef = useRef<HTMLFormElement>(null);

  const { time, setTime, control, isSubmitted, errors, onFormSubmit } = useEmailSubscriptionForm({
    onSuccess,
    metrics,
    auth,
  });

  const inputRenderer = ({ field }: { field: ControllerRenderProps<FormState> }) => {
    return (
      <InputWithRef
        type="text"
        enableAutoComplete={true}
        autoCompleteName={FORM_FIELDS.EMAIL}
        placeholder={l10n('emailSubscription.form.placeholder')}
        className={styles.input}
        // Set time to trigger first error shower tooltip
        onFocus={() => setTime(Date.now())}
        specificLocators="email-input"
        {...field}
      />
    );
  };

  return (
    <form ref={formRef} onSubmit={onFormSubmit} className={cls(styles.wrapper, className)}>
      <FirstErrorShower
        time={time}
        show={true}
        errors={isSubmitted ? errors : defaultTooltipErrors}
        container={formRef.current}
        tooltipClassName={cls({ [styles.tooltip]: !isSubmitted })}
      />

      <Controller name={FORM_FIELDS.EMAIL} control={control} render={inputRenderer} />

      <Button type="submit" withFullWidth={true} specificLocators="submit-button">
        {l10n('emailSubscription.form.button')}
      </Button>
    </form>
  );
};

export default SubscriptionForm;
